


























import Vue from "vue";

export default Vue.extend({
  name: "ListItem",
  props: {
    read: {
      type: [Boolean, Number],
      default: false,
    },
    date: { type: [String, Number] },
    header: { type: String },
    title: { type: String },
    footer: { type: String },
  },
});
